



















































import { defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { ContactPoint } from '@/store/types';
import { isNotEmpty, isValidEmailAddress } from '@/utils/rules';

export default defineComponent({
	props: {
		value: {
			type: Array as () => Array<ContactPoint>,
			required: true,
		},
	},
	setup(props) {
		const contactPoints = ref<Array<ContactPoint>>([]);

		const handleAddNewContactPoint = () => {
			contactPoints.value.push({
				name: '',
				telephone: '',
				email: '',
				contactType: '',
				organization: '',
			});
		};

		const handleRemoveContactPoint = (index: number) => {
			contactPoints.value.splice(index, 1);
		};

		const assignValues = (value: Array<ContactPoint>) => {
			contactPoints.value = value;
		};

		onMounted(() => {
			assignValues(props.value);
		});

		watch(
			() => props.value,
			(contactPoints) => assignValues(contactPoints)
		);

		return {
			contactPoints,
			handleAddNewContactPoint,
			handleRemoveContactPoint,
			isNotEmpty,
			isValidEmailAddress,
		};
	},
});
